import { render, staticRenderFns } from "./contractProcedureInfo.vue?vue&type=template&id=99c72ec2&scoped=true"
import script from "./contractProcedureInfo.vue?vue&type=script&lang=js"
export * from "./contractProcedureInfo.vue?vue&type=script&lang=js"
import style0 from "./contractProcedureInfo.vue?vue&type=style&index=0&id=99c72ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c72ec2",
  null
  
)

export default component.exports